import { Horse } from "./horse";

export class NominationHorseSlot {
    id: number;
    horseId: number;
    horse: Horse;
    
    nominationId: number;
    year: number;
}


// WEBPACK FOOTER //
// ./src/model/nominationHorseSlot.ts